import { useTranslation } from '@edreamsodigeo/frontend-core';

export type CampaignSuffix = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G' | '';

// no Suffix: Spring Deals
// A: Hotel Days
// B: Flash Sale
// C: Prime Day
// D: Saving Fest
// E: Black Week
// F: Summer Sale
// G: NEW Summer Sale

export const useCampaignSuffix = (): CampaignSuffix => {
  const { t } = useTranslation();
  const campaignType = t('campaignType');

  switch (campaignType) {
    case 'A':
    case 'B':
    case 'C':
    case 'D':
    case 'E':
    case 'F':
    case 'G':
      return campaignType;
    default:
      return '';
  }
};
